import styled from "styled-components";

export const StyledFooter = styled.footer`
  background-color: var(--secondary-color);
  color: var(--light-text);
  padding: 80px 0 20px;

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  @media (max-width: 576px) {
    padding: 50px 0 20px;
  }
`;

export const FooterContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 50px;
  margin-bottom: 50px;

  @media (max-width: 992px) {
    grid-template-columns: 1fr 1fr;
    gap: 30px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 40px;
    text-align: center;
  }
`;
export const FooterQr = styled.div`
  text-align: center;

  h3 {
    font-size: 1.2rem;
    margin-bottom: 15px;
    color: var(--light-text);
  }

  img {
    width: 180px;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  }

  @media (max-width: 768px) {
    img {
      width: 140px;
    }
  }
`;

export const FooterLogo = styled.div`
  img {
    height: 100px;
    margin: 0 auto 15px auto;
    display: block;
  }

  .branding {
    font-size: 1.3rem;
    line-height: 1.6;
    font-weight: bold;
    text-align: center;

    .highlight {
      color: var(--primary-color);
    }

    .white {
      color: var(--light-text);
    }
  }

  @media (max-width: 768px) {
    img {
      height: 80px;
    }

    .branding {
      font-size: 0.8rem;
    }
  }
`;

export const FooterLinks = styled.div`
  h3 {
    font-size: 1.2rem;
    margin-bottom: 20px;
    color: var(--light-text);
    align-items: center;
    text-align: center;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    align-items: center;
    text-align: center;
  }

  li {
    margin-bottom: 10px;
  }

  a {
    color: var(--light-text);
    opacity: 0.8;
    text-decoration: none;
    transition: all 0.3s ease;

    &:hover {
      color: var(--primary-color);
      opacity: 1;
    }
  }

  @media (max-width: 768px) {
    ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 20px;
    }

    li {
      margin-bottom: 0;
    }
  }

  @media (max-width: 480px) {
    ul {
      flex-direction: column;
      gap: 15px;
    }
  }
`;
export const FooterSocial = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  h3 {
    font-size: 1.2rem;
    margin-bottom: 20px;
    color: var(--light-text);
  }

  .qr-area {
    margin-top: 30px;

    h3 {
      font-size: 1.2rem;
      margin-bottom: 15px;
      color: var(--light-text);
    }

    img {
      width: 120px;
      height: auto;
      border-radius: 8px;
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    }
  }

  @media (max-width: 768px) {
    .qr-area {
      margin-top: 20px;

      img {
        width: 100px;
      }
    }
  }
`;

export const SocialIcons = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 40px);
  grid-gap: 15px;
  justify-content: center;
  margin-bottom: 10px;

  a {
    width: 40px;
    height: 40px;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--light-text);
    font-size: 1.2rem;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-3px);
    }
  }

  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 35px);

    a {
      width: 35px;
      height: 35px;
      font-size: 1rem;
    }
  }
`;

export const FooterBottom = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 20px;
  text-align: center;

  p {
    color: var(--light-text);
    opacity: 0.6;
    font-size: 0.9rem;
  }

  @media (max-width: 480px) {
    p {
      font-size: 0.8rem;
    }
  }
`;
